import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  NavItem,
  NavLink,
  Row,
  TabContent,
} from "reactstrap"
import classnames from "classnames"
import { Link } from "react-router-dom"
import classNames from "classnames"
import CPSTypeTab from "./CPSTypeTab"
import CPSRequestDataTab from "./CPSRequestDataTab"
import CPSSampleTab from "./CPSSampleTab"
import CPSConfirmationTab from "./CPSConfirmationTab"
import { useLoading, useQuery } from "helpers/custom_hooks"
import { GetCPSRequestByID } from "helpers/backend_helper"
import { IsCPSModuleEnabled } from "helpers/misc_helpers"
import { useNavigate } from "react-router-dom"

const CPSWizard = () => {
  const setLoading = useLoading()
  const navigate = useNavigate()
  const [activeTab, setactiveTab] = useState(1)
  const [passedSteps, setPassedSteps] = useState([1])
  const [isCPSEnabled, setIsCPSEnabled] = useState(undefined)
  const [permissionChecked, setPermissionChecked] = useState(false)
  const [request, setRequest] = useState({
    type: "", // Programming or Sleeving
    articleDescription: "",
    customerOrderNumber: "",
    mpn: "",
    manufacturer: "",
    packageType: "",
    deliveryForm: "",
    supplyForm: "",
    needType: "", // One-time or Annual
    quantity: "",
    safetyStockMin: "",
    safetyStockMax: "",
    customerSupply: true, // Always true - customer always supplies
    fileUpload: null,
    sampleRequired: false,
    sampleQuantity: "",
    samplePrice: "",
    desiredDeliveryDate: "",
    sampleDeliveryDate: "",
    // Sub-request specific fields
    isSubRequest: false,
    parentID: null,
    parentRequestId: null,
    parentRequestNumber: "",
  })

  const navLinks = ["CPS Type", "Request Data", "Requirements", "Confirmation"]

  const query = useQuery()
  const id = query.get("id")

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  useEffect(() => {
    if (activeTab == navLinks.length + 1) setPassedSteps([])
  }, [activeTab])

  useEffect(() => {
    const checkPermission = async () => {
      const enabled = await IsCPSModuleEnabled()
      setIsCPSEnabled(enabled)
      setPermissionChecked(true)
      if (!enabled) {
        return
      }
      if (id) {
        loadCPSRequestByID()
      } else {
        // Check if this is a sub-request creation
        loadSubRequestData()
      }
    }
    checkPermission()
  }, [id])

  const loadSubRequestData = () => {
    const subRequestData = sessionStorage.getItem("subRequestData")
    if (subRequestData) {
      try {
        const data = JSON.parse(subRequestData)
        setRequest({
          type: data.type, // Fixed to "Programming"
          articleDescription: data.articleDescription,
          customerOrderNumber: "",
          mpn: data.mpn,
          manufacturer: data.manufacturer,
          packageType: data.packageType,
          deliveryForm: data.deliveryForm,
          supplyForm: data.supplyForm,
          needType: data.needType, // Fixed to "one-time"
          quantity: data.quantity.toString(),
          safetyStockMin: "",
          safetyStockMax: "",
          customerSupply: data.customerSupply,
          fileUpload: null,
          sampleRequired: data.sampleRequired,
          sampleQuantity:
            data.sampleQuantity && data.sampleQuantity > 10
              ? "10"
              : data.sampleQuantity
              ? data.sampleQuantity.toString()
              : "",
          samplePrice: "",
          desiredDeliveryDate: data.desiredDeliveryDate,
          sampleDeliveryDate: "",
          // Sub-request specific fields
          isSubRequest: true,
          parentID: data.parentID,
          parentRequestId: data.parentRequestId,
          parentRequestNumber: data.parentRequestNumber,
        })
        // Clear the session storage after loading
        sessionStorage.removeItem("subRequestData")
      } catch (error) {
        console.error("Error loading sub-request data:", error)
      }
    }
  }

  const loadCPSRequestByID = async _ => {
    setLoading(true)
    try {
      const result = await GetCPSRequestByID(id)
      if (result) {
        // Transform API data to frontend format
        setRequest({
          type: result.type,
          articleDescription: result.articleDescription,
          customerOrderNumber: result.customerOrderNumber || "",
          mpn: result.mpn,
          manufacturer: result.manufacturer,
          packageType: result.packageType,
          deliveryForm: result.deliveryForm,
          supplyForm: result.supplyForm,
          needType: result.needType === "one-time" ? "one-time" : "annual",
          quantity: result.quantity.toString(),
          safetyStockMin: result.safetyStockMin
            ? result.safetyStockMin.toString()
            : "",
          safetyStockMax: result.safetyStockMax
            ? result.safetyStockMax.toString()
            : "",
          customerSupply: result.customerSupply === 1,
          fileUpload: null,
          sampleRequired: result.sampleRequired === 1,
          sampleQuantity: result.sampleQuantity
            ? result.sampleQuantity.toString()
            : "",
          samplePrice: result.samplePrice ? result.samplePrice.toString() : "",
          desiredDeliveryDate: result.desiredDeliveryDate || "",
          sampleDeliveryDate: result.sampleDeliveryDate || "",
          instructions: result.instructions || "",
          notes: result.notes || "",
        })
      }
    } catch (error) {
      console.error("Error loading CPS request:", error)
    }
    setLoading(false)
  }

  const nextTab = steps => {
    toggleTab(activeTab + steps)
  }
  const previousTab = _ => toggleTab(activeTab - 1)

  if (!permissionChecked || isCPSEnabled === undefined) {
    return (
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <div className="text-center">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }

  if (!isCPSEnabled) {
    return (
      <React.Fragment>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="bx bx-home h2" />
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col>
                <Card className="overflow-hidden">
                  <CardBody className="text-center">
                    <h1 className="display-2 fw-medium">
                      4<i className="bx bx-buoy bx-spin text-primary display-3" />
                      3
                    </h1>
                    <h4 className="text-uppercase">
                      Sorry, you are not allowed to view this page
                    </h4>
                    <p className="text-primary">
                      This is a premium feature. To use this feature, please
                      upgrade your license!
                    </p>
                    <div className="mt-5 text-center">
                      <Link
                        className="btn btn-primary waves-effect waves-light "
                        to="/settings?tab=2"
                      >
                        Upgrade Account
                      </Link>
                      <br />
                      <Link className=" d-block mt-4" to="/dashboard">
                        <i className="bx bx-left-arrow-alt" />
                        Back to Dashboard
                      </Link>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <Card className="overflow-hidden">
                <CardBody className="">
                  <h4 className="card-title mb-4">
                    RFQ CPS Programming/Sleeving
                  </h4>
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        {navLinks.map((item, index) => (
                          <NavItem
                            key={index}
                            className={classNames({
                              current: activeTab === index + 1,
                            })}
                          >
                            <NavLink
                              className={classnames({
                                current: activeTab === index + 1,
                              })}
                              onClick={() => {
                                setactiveTab(index + 1)
                              }}
                              disabled={
                                !(passedSteps || []).includes(index + 1)
                              }
                            >
                              <span className="number">{index + 1}.</span>{" "}
                              {item}
                            </NavLink>
                          </NavItem>
                        ))}
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        <CPSTypeTab
                          nextTab={nextTab}
                          previousTab={previousTab}
                          request={request}
                          setRequest={setRequest}
                        />

                        <CPSRequestDataTab
                          nextTab={nextTab}
                          previousTab={previousTab}
                          request={request}
                          setRequest={setRequest}
                        />

                        <CPSSampleTab
                          nextTab={nextTab}
                          previousTab={previousTab}
                          request={request}
                          setRequest={setRequest}
                        />

                        <CPSConfirmationTab
                          request={request}
                          setRequest={setRequest}
                          nextTab={nextTab}
                          previousTab={previousTab}
                        />
                      </TabContent>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CPSWizard
